import { baseApi } from '../apiProvider';
import { RequestSendMessage } from '../models/request/requestSendMessage';
import { ResponseMessage } from '../models/response/responseMessage';
import { ResponseMessageHistory } from '../models/response/responseMessageHistory';

const messageAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // send message to channel
    sendMessage: builder.mutation<ResponseMessage, RequestSendMessage>({
      query: (message: RequestSendMessage) => ({
        url: '/v0/messages',
        method: 'POST',
        body: message,
      }),
      invalidatesTags: ['Mission'],
    }),
    // get message by live id
    getMessage: builder.mutation<Array<ResponseMessageHistory>, string>({
      query: (param: string) => ({
        url: `/v0/messages?target=${param}`,
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useSendMessageMutation, useGetMessageMutation } = messageAPI;
